import { FC } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FolderIcon,
  ClipboardCheckIcon,
  GlobeAltIcon,
} from '@heroicons/react/outline';
import classNames from 'classnames';
import Button from '../Button';

const LibraryHeaderButtons: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const isMyResources = pathname === '/library';
  const isStandardAssessments = pathname === '/library/standard-assessments';
  const isDiscover = pathname === '/library/discover';

  return (
    <div className="flex flex-row items-center gap-2">
      <Button
        IconComponent={FolderIcon}
        iconPosition="left"
        theme="secondary"
        size="small"
        title="My resources"
        onClick={() => navigate('/library')}
        className={classNames({
          'bg-secondary-20': isMyResources,
        })}
      />
      <Button
        IconComponent={ClipboardCheckIcon}
        iconPosition="left"
        theme="secondary"
        size="small"
        title="Standard Assessments"
        onClick={() => navigate('/library/standard-assessments')}
        className={classNames({
          'bg-secondary-20': isStandardAssessments,
        })}
      />
      <Button
        IconComponent={GlobeAltIcon}
        iconPosition="left"
        theme="secondary"
        size="small"
        title="Discover"
        onClick={() => navigate('/library/discover')}
        className={classNames({
          'bg-secondary-20': isDiscover,
        })}
      />
    </div>
  );
};

export default LibraryHeaderButtons;
